import {breakpoints} from '../constants/breakpoints';
import STATE from '../constants/state';

const selectors = {
  section: '.js-video-section',
  yt: '.js-video-section-yt',
  poster: '.js-video-section-poster',
  video: '.js-video-section-video',
  btn: '.js-video-player-btn',
  iframe: 'iframe',
  source: 'source',
};

const ytHandler = ({yt, poster}) => {
  yt.classList.add(STATE.active);
  yt.innerHTML = yt.textContent;

  const iframe = yt.querySelector(selectors.iframe);

  iframe.addEventListener('load', () => {
    poster.classList.add(STATE.active);
  });
};

const videoHandler = ({video, poster}) => {
  const sources = video.querySelectorAll(selectors.source);
  sources.forEach((source) => {
    if (window.innerWidth < breakpoints.mobile) {
      source.setAttribute('src', source.dataset.mobileVid);
    } else {
      source.setAttribute('src', source.dataset.desktopVid);
    }
  });

  video.load();

  video.addEventListener('canplay', () => {
    poster.classList.add(STATE.active);
    video.play();
  });
};

const handleVideoSection = () => {
  const sections = document.querySelectorAll(selectors.section);

  if (sections.length === 0) return;

  sections.forEach((section) => {
    const yt = section.querySelector(selectors.yt);
    const poster = section.querySelector(selectors.poster);
    const video = section.querySelector(selectors.video);
    const btn = section.querySelector(selectors.btn);

    const posterHandler = () => {
      btn.classList.add(STATE.active);

      if (yt) {
        ytHandler({yt, poster});
      } else if (video) {
        videoHandler({video, poster});
      }
    };

    poster.addEventListener('click', posterHandler, {once: true});
  });
};

export default handleVideoSection;
